/* eslint-disable @typescript-eslint/ban-ts-comment */
import pt_br from './i18n/pt_br'
import en_us from './i18n/en_us'

import { LiveApi } from 'live/lib/api'
import i18n from 'live/services/i18n'
import Router from 'live/services/router'
import locale from 'live/init/global-locale'
import MenuService from 'live/services/menu'
import React from 'react'

import '../shared'

const localeFiles = {
    pt_br,
    en_us
}

i18n.add(localeFiles[locale])

const ROUTE = 'completions-overview'

Router.route(
    `/${ROUTE}`,
    React.lazy(() => import('./pages/completions-overview/CompletionsOverview.route')),
    'completions-overview',
    { hideFooter: true }
)

const menuItem = {
    alias: ROUTE,
    selectedAliases: [ROUTE],
    name: i18n('Completions Overview'),
    order: 0.5,
    url: `/#/${ROUTE}`,
    config: {
        showOnMobile: true
    }
}

MenuService.register(menuItem, 'regular')

LiveApi.HomePages.register({
    key: 'completions-overview',
    label: 'Completions Overview',
    existsOnMenu: true,
    url: `/#/${ROUTE}`,
    permissions: []
})
